<div
  class="flex flex-col items-center justify-start min-h-screen text-center pt-20 p-4"
>
  <img
    src="assets/actively-logo.png"
    [alt]="'notFound.logoAlt' | translate"
    class="w-32 mb-6 cursor-pointer"
    (click)="onRedirect()"
  />

  <h1 class="text-4xl font-bold text-gray-900 mb-4">{{ 'notFound.title' | translate }}</h1>
  <p class="text-lg text-gray-600 mb-6">{{ 'notFound.subtitle' | translate }}</p>

  <button
    class="px-6 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition-colors"
    (click)="onRedirect()"
  >
    {{ 'notFound.goHome' | translate }}
  </button>
</div>
